import script from "./MenuGalleryApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuGalleryApp.vue?vue&type=script&setup=true&lang=ts"

import "./MenuGalleryApp.vue?vue&type=style&index=0&id=72e2ccde&scoped=true&lang=scss"

import exportComponent from "/var/www/twledodo-booking-fondueretro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e2ccde"]])

export default __exports__